const manufacturerDetails = [
  {
    name: "abbvie",
    hin: true,
    policy_doc_url: "/resources/abbvie/policy.pdf",
  },
  {
    name: "amgen",
    hin: true,
    policy_doc_url: "/resources/amgen/policy.pdf",
  },
  {
    name: "astellas",
    hin: true,
    policy_doc_url: "/resources/astellas/policy.pdf",
  },
  {
    name: "astrazeneca",
    hin: true,
    policy_doc_url: "/resources/astrazeneca/policy.pdf",
  },
  {
    name: "bausch_n_lomb",
    hin: true,
    policy_doc_url: "/resources/bausch_n_lomb/policy.pdf",
  },
  {
    name: "bayer",
    hin: true,
    policy_doc_url: "/resources/bayer/policy.pdf",
  },
  {
    name: "biogen",
    hin: true,
    policy_doc_url: "/resources/biogen/policy.pdf",
  },
  {
    name: "bristol_myers_squibb",
    hin: true,
    policy_doc_url: "/resources/bristol_myers_squibb/policy.pdf",
  },
  {
    name: "cytokinetics",
    hin: true,
    policy_doc_url: "/resources/cytokinetics/policy.pdf",
  },
  {
    name: "eisai",
    hin: true,
    policy_doc_url: "/resources/eisai/policy.pdf",
  },
  {
    name: "eli_lilly",
    hin: true,
    policy_doc_url: "/resources/eli_lilly/policy.pdf",
  },
  {
    name: "exelixis",
    hin: true,
    policy_doc_url: "/resources/exelixis/policy.pdf",
  },
  {
    name: "genentech",
    hin: true,
    policy_doc_url: "/resources/genentech/policy.pdf",
  },
  {
    name: "emd_serono",
    hin: true,
    policy_doc_url: "/resources/emd_serono/policy.pdf",
  },
  {
    name: "boehringer_ingelheim",
    hin: true,
    policy_doc_url: "/resources/boehringer_ingelheim/policy.pdf",
  },
  {
    name: "glaxosmithkline",
    hin: true,
    policy_doc_url: "/resources/glaxosmithkline/policy.pdf",
  },
  {
    name: "incyte",
    hin: true,
    policy_doc_url: "/resources/incyte/policy.pdf",
  },
  {
    name: "jazz",
    hin: true,
    policy_doc_url: "/resources/jazz/policy.pdf",
  },
  {
    name: "johnson_n_johnson",
    hin: true,
    policy_doc_url: "/resources/johnson_n_johnson/policy.pdf",
  },
  {
    name: "leo",
    hin: true,
    policy_doc_url: "/resources/policy.pdf",
  },
  {
    name: "liquidia",
    hin: true,
    policy_doc_url: "/resources/liquidia/policy.pdf",
  },
  {
    name: "merck",
    hin: true,
    policy_doc_url: "/resources/merck/policy.pdf",
  },
  {
    name: "mtpa",
    hin: true,
    policy_doc_url: "/resources/mtpa/policy.pdf",
  },
  {
    name: "novo_nordisk",
    hin: true,
    policy_doc_url: "/resources/novo_nordisk/policy.pdf",
  },
  {
    name: "novartis",
    hin: true,
    policy_doc_url: "/resources/novartis/policy.pdf",
  },
  {
    name: "pfizer",
    hin: false,
    policy_doc_url: "/resources/pfizer/policy.pdf",
  },
  {
    name: "pharmacyclics",
    hin: true,
    policy_doc_url: "/resources/abbvie/policy.pdf",
  },
  {
    name: "sandoz",
    hin: true,
    policy_doc_url: "/resources/sandoz/policy.pdf",
  },
  {
    name: "sanofi",
    hin: true,
    policy_doc_url: "/resources/sanofi/policy.pdf",
  },
  {
    name: "sobi",
    hin: true,
    policy_doc_url: "/resources/sobi/policy.pdf",
  },
  {
    name: "stemline",
    hin: true,
    policy_doc_url: "/resources/stemline/policy.pdf",
  },
  {
    name: "sumitomo",
    hin: true,
    policy_doc_url: "/resources/sumitomo/policy.pdf",
  },
  {
    name: "teva",
    hin: false,
    policy_doc_url: "/resources/teva/policy.pdf",
  },
  {
    name: "ucb",
    hin: true,
    policy_doc_url: "/resources/ucb/policy.pdf",
  },
  {
    name: "takeda",
    hin: true,
    policy_doc_url: "/resources/takeda/policy.pdf",
  },
  {
    name: "vertex",
    hin: true,
    policy_doc_url: "/resources/vertex/policy.pdf",
  },
  {
    name: "viatris",
    hin: true,
    policy_doc_url: "/resources/viatris/policy.pdf",
  },
];

export const manufacturers = manufacturerDetails;

// Minimal per manufacturer+network notice/map config actually read by the live designation flow
// (shared/designations/{LdnDesignationForm,PharmacySelect}.jsx), for AbbVie's LDN drugs + Imbruvica
// only. The full audit dataset (all manufacturers, all networks, plus documentation-only fields)
// lives server-side in app/models/manufacturers/designation_config.rb and is passed to the
// /designation_preview page as a prop, so it never ships in the public JS bundle.
export const manufacturerDesignationOptions = {
  abbvie: {
    decnupaz: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: true,
      disableHinNotice: false,
      disableInHouseNotice: false,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
    duopa: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: false,
      disableHinNotice: false,
      disableInHouseNotice: true,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
    elahere: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: true,
      disableHinNotice: false,
      disableInHouseNotice: false,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
    emrelis: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: true,
      disableHinNotice: false,
      disableInHouseNotice: false,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
    juvmo: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: false,
      disableHinNotice: false,
      disableInHouseNotice: true,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
    venclexta: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: false,
      disableHinNotice: false,
      disableInHouseNotice: true,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
    vyalev: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: true,
      disableHinNotice: false,
      disableInHouseNotice: true,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
  },
  pharmacyclics: {
    imbruvica: {
      disableEmptyCpsNotice: true,
      disableGranteeNotice: false,
      disableHinNotice: false,
      disableInHouseNotice: true,
      disableNoCpsInRangeNotice: false,
      disableWhollyOwnedNotice: true,
      excludeCentralFill: false,
      hasMap: false,
    },
  },
};
